import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class MercadoLibreService extends ApiService {
    public plataformaId = 1;
    constructor(protected http: HttpService) {
        super(http);
        this.url = `api/mercadolibre/${this.plataformaId}/ordenes/`;
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/ladecuador-dev/src/app/shared/services/api/mercado-libre.service.ts